 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"layouts3":"layouts3","partners":"partners","layouts4":"layouts4","layouts0":"layouts0","layouts1":"layouts1","layouts2":"layouts2","login":"login","mozgo-party":"mozgo-party","partners-order-game0":"partners-order-game0","partners-order-game2":"partners-order-game2","partners-order-game4":"partners-order-game4","partners-order-game1":"partners-order-game1","partners-order-game3":"partners-order-game3"}[chunkId]||chunkId) + "." + {"chunk-1423ee38":"a91d1dc7","chunk-2022de42":"2fe7cd1b","chunk-eedb2ea2":"775ffd16","chunk-2d22bf42":"c2b24a0b","chunk-1f0018e0":"07d21e39","chunk-2eab9651":"598a7b40","chunk-73b342d0":"d323c8e8","chunk-16d2cd4a":"b3523b31","chunk-3cea267a":"e79f1690","chunk-08ef8b24":"954f8f06","chunk-9cb87dfc":"e59395b1","chunk-2e7a24b5":"07a3716a","chunk-37c8a764":"8ae3b684","chunk-7ed0e444":"06928ffe","chunk-f03e7b5a":"663007ff","chunk-250cf160":"70fa0f8e","chunk-45b380ce":"1de91f32","chunk-78489950":"653c3bc1","chunk-d6062056":"ad9f52be","layouts3":"d8ca993b","partners":"f8a7c300","chunk-e0adfbe0":"b4854e0e","chunk-83ff7f72":"87fb13f9","layouts4":"e309c3f9","chunk-457a961c":"6f075d36","chunk-ab302338":"d5020b8b","chunk-1e7ab32c":"a7a35850","chunk-55e90213":"775f96ae","chunk-cb5d7bb2":"f7283201","chunk-52e9098a":"17d3f804","chunk-bae960da":"581db473","chunk-1b8855e0":"1b401890","chunk-dc20d4c0":"c4bd45ea","chunk-c8e0d8c0":"0aecf99f","layouts0":"774de588","layouts1":"a7b4f446","layouts2":"5a0f30e1","login":"22cfcb01","mozgo-party":"0ce84448","partners-order-game0":"a7a5f624","partners-order-game2":"9bd32087","partners-order-game4":"5e64ba58","partners-order-game1":"664172ae","partners-order-game3":"d49bfc87"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1423ee38":1,"chunk-eedb2ea2":1,"chunk-1f0018e0":1,"chunk-73b342d0":1,"chunk-16d2cd4a":1,"chunk-08ef8b24":1,"chunk-37c8a764":1,"chunk-7ed0e444":1,"chunk-f03e7b5a":1,"chunk-250cf160":1,"chunk-45b380ce":1,"chunk-78489950":1,"chunk-d6062056":1,"layouts3":1,"partners":1,"chunk-83ff7f72":1,"layouts4":1,"chunk-457a961c":1,"chunk-ab302338":1,"chunk-1e7ab32c":1,"chunk-55e90213":1,"chunk-cb5d7bb2":1,"chunk-52e9098a":1,"chunk-bae960da":1,"chunk-1b8855e0":1,"chunk-dc20d4c0":1,"chunk-c8e0d8c0":1,"partners-order-game0":1,"partners-order-game2":1,"partners-order-game4":1,"partners-order-game1":1,"partners-order-game3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"layouts3":"layouts3","partners":"partners","layouts4":"layouts4","layouts0":"layouts0","layouts1":"layouts1","layouts2":"layouts2","login":"login","mozgo-party":"mozgo-party","partners-order-game0":"partners-order-game0","partners-order-game2":"partners-order-game2","partners-order-game4":"partners-order-game4","partners-order-game1":"partners-order-game1","partners-order-game3":"partners-order-game3"}[chunkId]||chunkId) + "." + {"chunk-1423ee38":"1fdc2609","chunk-2022de42":"31d6cfe0","chunk-eedb2ea2":"45eced42","chunk-2d22bf42":"31d6cfe0","chunk-1f0018e0":"91778056","chunk-2eab9651":"31d6cfe0","chunk-73b342d0":"012a9b8f","chunk-16d2cd4a":"5683bac3","chunk-3cea267a":"31d6cfe0","chunk-08ef8b24":"1d2cf48b","chunk-9cb87dfc":"31d6cfe0","chunk-2e7a24b5":"31d6cfe0","chunk-37c8a764":"056d6e70","chunk-7ed0e444":"243a8d05","chunk-f03e7b5a":"2c753a55","chunk-250cf160":"be383fb9","chunk-45b380ce":"9dc89251","chunk-78489950":"7941a6a3","chunk-d6062056":"59b140ab","layouts3":"0f864716","partners":"c161a5ff","chunk-e0adfbe0":"31d6cfe0","chunk-83ff7f72":"c450ac54","layouts4":"4cd70f82","chunk-457a961c":"034d0b14","chunk-ab302338":"ad5a6c68","chunk-1e7ab32c":"1574b889","chunk-55e90213":"e85c0d2c","chunk-cb5d7bb2":"8cf34d3c","chunk-52e9098a":"4241d150","chunk-bae960da":"37e59660","chunk-1b8855e0":"a35fe017","chunk-dc20d4c0":"39bf9703","chunk-c8e0d8c0":"ee2e3a6a","layouts0":"31d6cfe0","layouts1":"31d6cfe0","layouts2":"31d6cfe0","login":"31d6cfe0","mozgo-party":"31d6cfe0","partners-order-game0":"fb149e8b","partners-order-game2":"5264df8e","partners-order-game4":"6c42c1b3","partners-order-game1":"30c7b1b7","partners-order-game3":"165db281"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
